import { ReviewItem } from '@silvertours/common-landingpages-view';
import { I18nLegacy, String } from '@silvertours/front-legacy-shared';
import { NumberFormatOptions, useFormatter, useTranslations } from 'next-intl';

const hosts = {
  de: 'billiger-mietwagen.de',
  fr: 'carigami.fr',
};

export const useReviewItem = (item: ReviewItem) => {
  const { aggregateRating, date, locationName, providerQuote, reviewerName } =
    item;
  const ratingFormatOptions: NumberFormatOptions = {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  };

  const { important } = I18nLegacy;

  const format = useFormatter();
  const { language } = I18nLegacy.useLocale();

  const t = useTranslations('features.trustLegacy.feedback.reviewItem');

  const dateLabel = String.useRelativeDate(date);

  const host = hosts[language as 'de' | 'fr'];

  const ratingLabel = t.rich('ratingLabel', {
    rating: format.number(aggregateRating, ratingFormatOptions),
    important,
  }) as string;

  const ratingLocation = t.rich('ratingLocation', {
    location: locationName,
    important,
  }) as string;

  const reviewerLabel = t('reviewerLabel', {
    reviewerName,
  });

  const providersQuoteTitleLabel = t('providersQuoteTitleLabel', {
    organizers: providerQuote.organizers,
    rentalCompanies: providerQuote.rentalCompanies,
  });

  const siteQuoteTitleLabel = t('siteQuoteTitleLabel', {
    host,
  });

  return {
    host,
    providersQuoteTitleLabel,
    reviewerLabel,
    siteQuoteTitleLabel,
    header: {
      aggregateRating,
      dateLabel,
      ratingLabel,
      locationName,
      ratingLocation,
    },
  };
};
